import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { BiPieChart } from "react-icons/bi";
import { IoSettingsOutline } from "react-icons/io5";
import "./MobileMenu.css"; // Reuse existing mobile styles

const MobileBusinessUserMenu = ({ selectedBusiness, onLogout, onClose, hamburgerRef }) => {
  const businessId = selectedBusiness?.id;
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedOutsideMenu = menuRef.current && !menuRef.current.contains(event.target);
      const clickedHamburger = hamburgerRef?.current?.contains(event.target);

      if (clickedOutsideMenu && !clickedHamburger) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose, hamburgerRef]);

  useEffect(() => {
    // Enables :active styles on iOS Safari
    const noop = () => {};
    document.addEventListener("touchstart", noop, { passive: true });
    return () => document.removeEventListener("touchstart", noop);
  }, []);

  return (
    <div className="mobile-menu-container" ref={menuRef}>
      <ul>
        {businessId && (
          <>
            <li>
              <Link to={`/bus-dashboard/business/${businessId}/cash-recon`} onClick={onClose}>
                <BiPieChart /> Cash-In
              </Link>
            </li>
            <li>
              <Link to={`/bus-dashboard/business/${businessId}/payroll-entry`} onClick={onClose}>
                <BiPieChart /> Payroll
              </Link>
            </li>
          </>
        )}
        <li>
          <Link to="/bus-dashboard/business/user/profile" onClick={onClose}>
            <IoSettingsOutline /> Settings
          </Link>
        </li>
        <li>
          <button className="logout-btn-mobile" onClick={onLogout}>Logout</button>
        </li>
      </ul>
    </div>
  );
};

export default MobileBusinessUserMenu;
